import React, { useEffect, useLayoutEffect, useState } from 'react';
import { useStore } from 'react-redux';
import { useHistory } from 'react-router-dom';
import useMedia from "use-media";
import { useRtoaster } from '../../../hooks/useRtoaster';
import { apiKeyCheck, versionGetApi ,GetTopMenuList} from "../../../const";
import golf from "../../../resources/RTCC/image/img_home/golf_home.jpg";
import common from '../../../resources/RTCC/js/common/common';
import { TopContentBlock } from '../../molecules/RTCC/topContentBlock';
import { TopMenuList } from '../../molecules/RTCC/topMenuList';

export const TopContainer = (props) => {
    const { setOutsideHoursFlg, setMenuTitle } = props;
    const history = useHistory();
    const store = useStore();

    //レスポンシブ対応
    const useMediaFlag = useMedia({ maxWidth: '960px' });
    const [isMobilePhone, setIsMobilePhone] = useState(false);

    //表示データ格納ステート
    const [displayData, setDisplayData] = useState([]);

    // rtoasterタグ生成
    useRtoaster();

    useLayoutEffect(() => {
        // リフレッシュ対応
        let state = store.getState().login;
        let apiKey = null;
        if (Object.keys(state).length !== 0) {
            apiKey = state.apiKey;
        }
        if (apiKey === null) {
            store.dispatch({ type: "CLEAR_STATE" });
            history.push("/reserve/login");
        }
        if (apiKey) {
            common.doPost(apiKeyCheck, { apikey: apiKey }, afterApiKeyCheck);
        }
        common.doPost(GetTopMenuList, {}, afterGetTopMenuList);
    },[])
    const afterApiKeyCheck = (res) => {
        if (!res.data) {
            console.log("バックからの戻り値false");
            store.dispatch({ type: "CLEAR_STATE" });
            history.push("/reserve/login");
        }
    }

    const afterGetTopMenuList = (res) => {
        if (res.data.resultCode === "0") {
            //表示オブジェクト詰め込み処理
            if(res.data.data !== null || res.data.data !== undefined || res.data.data.length !== 0){
                let siteList = [];
                res.data.data.map((displayData) => {
                    if(displayData.menu_use_check){
                        let message = displayData.menu_message.replaceAll("<br>", "\r\n");
                        let description = displayData.menu_description.replaceAll("<br>", "\r\n");
                        let displayObj = {
                            description:description,
                            overview:displayData.menu_overview,
                            message:message,
                            topContentAlt:displayData.menu_name,
                            topImageText:displayData.menu_name,
                            idName:displayData.menu_id,
                            url:displayData.menu_url,
                            imageUrl:displayData.menu_image_url,
                            menuUrl:displayData.menu_tab_image_url ,
                            switchflg:false,
                            menuSort:displayData.menu_sort,
                        }
                        siteList.push(displayObj);
                    }
                })
                //表示施設のソート処理
                siteList.sort(function(first,second){
                    if (first.menuSort > second.menuSort){
                        return 1;
                    }else if (first.menuSort < second.menuSort){
                        return -1;
                    }else{
                        return 0;
                    }
                })
                setDisplayData(siteList);
            }
        }
    }

    useEffect(() => {
        if (useMediaFlag) {
            setIsMobilePhone(true);
        } else {
            setIsMobilePhone(false);
        }
    }, [useMediaFlag]);

    useEffect(() => {
        common.doPost(versionGetApi, {}, afterVerCheck);
    })

    const afterVerCheck = (res) => {
        let flg = common.versionCheck(res.data.version);
        if (flg) {
            history.push("/reserve/login");
            return;
        }
    }

    return (
        <div>
            <TopMenuList data={displayData}/>
            {
                displayData.map((data)=>{
                    return(
                        <TopContentBlock
                            idName={data.idName}
                            isMobilePhone={isMobilePhone}
                            TopContentImage={data.imageUrl}
                            TopContentAlt={data.topContentAlt}
                            TopImageText={data.topImageText}
                            TopContentText={data.description}
                            menu={data.url}
                            popupData={data}
                            setOutsideHoursFlg={setOutsideHoursFlg}
                            setMenuTitle={setMenuTitle}
                        />
                    )
                })
            }
        </div>
    );
}
